import React from 'react';

const LazyImage = ({ 
  src, 
  alt, 
  className = '', 
  style = {},
  onLoad,
  ...props 
}) => {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      loading="lazy"
      decoding="async"
      onLoad={onLoad}
      {...props}
    />
  );
};

export default LazyImage;
